import { render, staticRenderFns } from "./GroupsManagementView.vue?vue&type=template&id=48faa05f&scoped=true"
import script from "./GroupsManagementView.vue?vue&type=script&lang=js"
export * from "./GroupsManagementView.vue?vue&type=script&lang=js"
import style0 from "./GroupsManagementView.vue?vue&type=style&index=0&id=48faa05f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faa05f",
  null
  
)

export default component.exports